import { compose, lifecycle, withHandlers, withStateHandlers } from 'recompose'
import { connect } from 'react-redux'
import { getLocationPathname } from 'selectors/getPageLocation'
import { getStoreLocatorPageExperience } from 'selectors/thirdPartyData'
import { STORE_LOCATOR_PAGE } from 'constant'
import StoreLocatorHaveResults from './StoreLocatorHaveResults'

const mapEventsHandlers = () => {
  const refs = {
    map: undefined
  }

  return {
    getMapRef: () => () => refs.map,
    onMapRefBecameAvailable: () => ref => {
      refs.map = ref
    },
    onItemSelected: ({
      setSelectedSearchResultAction,
      setAllowMapInteractionFlag
    }) =>
      ({ storeId, mapCenter: { latitude: lat, longitude: lng }}) => {
        // Disabling onMapBoundsChange till the next map idle
        setAllowMapInteractionFlag(false)
        setSelectedSearchResultAction(storeId)
        refs && refs.map && refs.map.panTo({ lat, lng })
      }
  }
}

const withSetCenterWhenResultsChange = lifecycle({
  componentDidUpdate(prevProps) {
    const {
      setAllowMapInteractionFlag,
      setInitialResultsLoadedFlag,
      allowMapInteraction,
      initialResultsLoaded
    } = this.props

    if (allowMapInteraction && !initialResultsLoaded) {
      setAllowMapInteractionFlag(false)
      setInitialResultsLoadedFlag(true)
    }
    if (prevProps.results !== this.props.results && this.props.results.length) {
      const { mapCenter: { latitude: lat, longitude: lng } = {}} = this.props.results[0] || {}
      const map = this.props.getMapRef() || { panTo() {} }

      setAllowMapInteractionFlag(false)
      map.panTo({ lat, lng })
    }
  },
  componentWillUnmount() {
    const { resetSearchAction } = this.props
    resetSearchAction()
  }
})

const withMapInteractionFlag = withStateHandlers({
  allowMapInteraction: false,
  initialResultsLoaded: false
}, {
  setAllowMapInteractionFlag: () => value => ({ allowMapInteraction: value }),
  setInitialResultsLoadedFlag: () => value => ({ initialResultsLoaded: value })
})

const mapStateToProps = state => ({
  enhancedStoreResultsEnabled: getLocationPathname(state) === STORE_LOCATOR_PAGE && getStoreLocatorPageExperience(state) === 'b'
})

export default compose(
  connect(mapStateToProps),
  withMapInteractionFlag,
  withHandlers(mapEventsHandlers),
  withSetCenterWhenResultsChange
)(StoreLocatorHaveResults)

